import { render, staticRenderFns } from "./GlobalStatistics.vue?vue&type=template&id=654a9ea0&"
import script from "./GlobalStatistics.vue?vue&type=script&lang=js&"
export * from "./GlobalStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports